var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultThumbnail2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D4DBE9",
    fillOpacity: 0.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2544 12C28.3992 12 31.4544 15.0528 31.4544 19.2C31.4544 23.3472 28.3992 26.4 24.2544 26.4C20.112 26.4 17.0544 23.3472 17.0544 19.2C17.0544 15.0528 20.112 12 24.2544 12ZM12 35.4528C14.1528 32.2848 17.7432 30.1728 21.8544 30.1728H26.6544C30.768 30.1728 34.356 32.2848 36.5088 35.4528C33.4416 38.736 29.0904 40.8 24.2544 40.8C19.4184 40.8 15.0672 38.736 12 35.4528Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultThumbnail2);
export default __webpack_public_path__ + "static/media/default_thumbnail2.a5a88665f0e66383b058ed6cef29d4d2.svg";
export { ForwardRef as ReactComponent };